import React from "react";
import { Pagination } from "@/lib/api";
import { Link } from "react-router-dom";
import chevronIcon from "@public/img/chevron-down.svg";
import "@/styles/pagination.css";

type PaginationViewProps = {
    pagination: Pagination;
    black?: boolean;
    onChange: (page: number) => void;
}

function pageItemClass(isActive: boolean): string {
    return "pagination__item" + (isActive ? " pagination__item--active" : "");
}

function navClass(direction: "prev" | "next"): string {
    return "pagination__nav pagination__nav--" + direction;
}

export default function PaginationView({ pagination, black, onChange }: PaginationViewProps) {
    if (pagination.total_pages <= 1) {
        return null;
    }

    const rootClass = "pagination" + (black ? " pagination--dark" : "");

    const handleClick = (e: React.MouseEvent<HTMLAnchorElement>, page: number) => {
        e.preventDefault();
        onChange(page);
    };

    return (
        <div className={rootClass}>
            {pagination.current_page > 1 && (
                <Link
                    to={`?page=${pagination.current_page - 1}`}
                    className={navClass("prev")}
                    onClick={(e) => handleClick(e, pagination.current_page - 1)}
                >
                    <img src={chevronIcon} alt="Previous" />
                    <span>قبلی</span>
                </Link>
            )}
            <Link
                to="?page=1"
                className={pageItemClass(pagination.current_page === 1)}
                onClick={(e) => handleClick(e, 1)}
            >
                <span>1</span>
            </Link>

            {pagination.total_pages <= 5 &&
                Array.from({ length: pagination.total_pages }, (_, index) => index + 2)
                    .filter((page) => page > 1 && page < pagination.total_pages)
                    .map((page) => (
                        <Link
                            key={page}
                            to={`?page=${page}`}
                            className={pageItemClass(pagination.current_page === page)}
                            onClick={(e) => handleClick(e, page)}
                        >
                            <span>{page}</span>
                        </Link>
                    ))}

            {pagination.total_pages > 5 && pagination.current_page > 3 && (
                <span className="pagination__ellipsis">...</span>
            )}

            {pagination.total_pages > 5 &&
                Array.from({ length: 5 }, (_, idx) => pagination.current_page - 2 + idx)
                    .filter((page) => page > 1 && page < pagination.total_pages)
                    .map((page) => (
                        <Link
                            key={page}
                            to={`?page=${page}`}
                            className={pageItemClass(pagination.current_page === page)}
                            onClick={(e) => handleClick(e, page)}
                        >
                            <span>{page}</span>
                        </Link>
                    ))}

            {pagination.total_pages > 5 && pagination.current_page < pagination.total_pages - 3 && (
                <span className="pagination__ellipsis">...</span>
            )}

            <Link
                to={`?page=${pagination.total_pages}`}
                className={pageItemClass(pagination.current_page === pagination.total_pages)}
                onClick={(e) => handleClick(e, pagination.total_pages)}
            >
                <span>{pagination.total_pages}</span>
            </Link>

            {pagination.has_more && (
                <Link
                    to={`?page=${pagination.next_page}`}
                    className={navClass("next")}
                    onClick={(e) => handleClick(e, pagination.next_page)}
                >
                    <span>بعدی</span>
                    <img src={chevronIcon} alt="Next" />
                </Link>
            )}
        </div>
    );
}
